import { InjectionToken } from '@angular/core';

export interface ILogger {
  debug(cause: string, value?: any, message?: string, stackTrace?: string): void;
  info(cause: string, value?: any, message?: string, stackTrace?: string): void;
  warn(cause: string, value?: any, message?: string, stackTrace?: string): void;
  error(cause: string, value?: any, message?: string, stackTrace?: string): void;
}

export const LOGGER_TOKEN = new InjectionToken<ILogger>('ILogger');